import React from "react";
import { Pressable } from "../../../../../pressable";

export function Link({
    handleClick,
    children,
}: {
    handleClick: () => void;
    children: React.ReactNode;
}) {
    return (
        <div className="link" onClick={handleClick}>
            <Pressable>
                <div className="bubble">
                    <div className="shadows"></div>
                    {children}
                    <div className="icon"></div>
                </div>
            </Pressable>
        </div>
    );
}
